import { createSlice } from '@reduxjs/toolkit'
import { getServices } from 'features/common'

const initialState = {
    services: [],
    loading: false,
    error: null
}

const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        setServices: (state, action) => {
            state.services = action.payload
            state.loading = false
            state.error = null
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
            state.loading = false
        }
    }
})

export const { setServices, setLoading, setError } = servicesSlice.actions

export const fetchServices = () => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const response = await getServices()
        dispatch(setServices(response))
    } catch (error) {
        dispatch(setError(error.message))
    }
}

export default servicesSlice.reducer 
